export function footerFunc() {
  
  let getUrl = location.host;
  var wpAjaxUrl;
  
  if(getUrl == 'tenga-brandsite.test'){
    wpAjaxUrl = 'http://tenga-brandsite.test/wp-admin/admin-ajax.php';
    
  }else if(getUrl == 'tenga-grobal-us.test'){
    wpAjaxUrl = 'http://tenga-grobal-us.test/wp-admin/admin-ajax.php';
    
  }else if(getUrl == 'tenga.iclip-staging.website'){
    wpAjaxUrl = 'https://tenga.iclip-staging.website/wp-admin/admin-ajax.php';
    
  }else if(getUrl == 'dev.tenga.co.jp'){
   wpAjaxUrl = 'https://dev.tenga.co.jp/wp-admin/admin-ajax.php';
    
  }else if(getUrl == 'www.tenga.co.jp'){
   wpAjaxUrl = 'https://www.tenga.co.jp/wp-admin/admin-ajax.php';
  }else if(getUrl == 'www.acceptee-tenga.com'){
   wpAjaxUrl = 'http://www.acceptee-tenga.com/wp-admin/admin-ajax.php';
  }else if(getUrl == 'us-dev.tenga.co'){
   wpAjaxUrl = 'https://us-dev.tenga.co/wp-admin/admin-ajax.php';
  }else if(getUrl == 'www.tenga.co'){
   wpAjaxUrl = 'https://www.tenga.co/wp-admin/admin-ajax.php';
  }else if(getUrl == 'global-tenga.acceptee-tenga.com'){
   wpAjaxUrl = 'http://global-tenga.acceptee-tenga.com/wp-admin/admin-ajax.php';
  }
  
  
  // Ajaxで送信
  $.ajax({
    url: wpAjaxUrl,
    method: 'post',
    data: {
      'action': 'view_sitename',
    },
  }).done(function (res) {
      $('#ajaxBannerInner').append(res);
  }).fail(function (xhr, textStatus, errorThrown) {
    console.log("NG:" + xhr.status);
  });
}